import {
  clearAllOfflineWebClockDataForChannelSwitch,
  resolvePendingOfflineWebClockClear,
} from './modules/webClock/utils/offlineWebClockStorage';
import {
  assertMobileRuntimeEnv,
  runMobileEnvChannelSwitchCleanup,
} from './modules/webClock/utils/mobileRuntimeConfig';

/**
 * Shared WebClock entry bootstrap (standard and mobile webpack profiles).
 * Mobile-specific checks no-op when `mobile` is absent from the URL.
 *
 * @param {() => void} renderApp
 * @returns {Promise<void>}
 */
export async function bootstrapWebClock(renderApp) {
  assertMobileRuntimeEnv();

  const { channelChanged, cleanupSucceeded } =
    await runMobileEnvChannelSwitchCleanup(
      clearAllOfflineWebClockDataForChannelSwitch
    );

  if (channelChanged && !cleanupSucceeded) {
    throw new Error(
      '[WebClock] Mobile env channel switch cleanup failed. ' +
        'Offline secure storage was not cleared.'
    );
  }

  const pendingClearResolved = await resolvePendingOfflineWebClockClear();

  if (!pendingClearResolved) {
    throw new Error(
      '[WebClock] Pending offline secure-storage cleanup failed. ' +
        'Offline secure storage was not cleared.'
    );
  }

  renderApp();
}
